

export const serviceData = 
[
  {
    "id": "13452543",
    "title": "ACC App",
    "img": "/light/assets/imgs/logo/Acc_logo.png",
    "desc": "A veterinary insurance card that provides care services, discounts, hotels and veterinary consultations.",
    "link": "/services-details",
    "images": [
      "/light/assets/imgs/service-img/Acc-app-img.webp",
      "/light/assets/imgs/service-img/Acc-landing.webp",
    ],
    "vid": "/light/assets/imgs/service-img/acc-landing-vid.mp4",
    "keyPoints": [
      "Comprehensive veterinary insurance card.",
      "Discounts on animal care services.",
      "Access to pet hotels and veterinary consultations.",
      "Comprehensive veterinary insurance card.",
      "Discounts on animal care services.",
      "Access to pet hotels and veterinary consultations."
    ],
    "callToAction": "Join ACC today to give your pets the best care possible!",
    "competitiveAdvantage": "Unique combination of insurance, discounts, and consultation services tailored for pet owners.",
    "url": "https://animalcc.com",
    "downloads": {
      "ios" : {
        "icon": "/light/assets/imgs/logo/ios_icon.png",
        "url": "https://apps.apple.com/sa/app/acc/id6740631352"
      },
      "android" : {
        "icon": "/light/assets/imgs/logo/android_icon.png",
        "url": "https://play.google.com/store/apps/details?id=com.ana.jay.acc&pli=1"
      }
    }
  },
  {
    "id": "2134545",
    "title": "SDC App",
    "img": "/light/assets/imgs/logo/sdc-logo.png",
    "desc": "A platform to search for personal trainers accredited by the platform within the clubs in which individuals participate, and the possibility of booking and paying per share inside or outside the club.",
    "link": "/services-details",
    "images": [
      "/light/assets/imgs/service-img/Sdc-app-img.webp",
      "/light/assets/imgs/service-img/Sdc-landing.webp",
    ],
    "vid": "/light/assets/imgs/service-img/sdc-landing-vid.mp4",
    "keyPoints": [
      "Find personal trainers within your club or nearby.",
      "Convenient booking and payment options.",
      "Support for training inside or outside the club."
    ],
    "callToAction": "Connect with professional trainers on SDC today and achieve your fitness goals!",
    "competitiveAdvantage": "Bridges the gap between trainers and clients with accredited professionals and streamlined booking.",
    "url": "https://sportdigitalclub.com",
    "downloads": {
      "ios" : {
        "icon": "/light/assets/imgs/logo/ios_icon.png",
        "url": "https://apps.apple.com/sa/app/sdc/id6740455592"
      },
      "android" : {
        "icon": "/light/assets/imgs/logo/android_icon.png",
        "url": "https://play.google.com/store/apps/details?id=com.ana.jay.sdc"
      }
    }
  },
  {
    "id": "1136788",
    "title": "IGI App",
    "img": "/light/assets/imgs/logo/anajay-logo.png",
    "desc": "An application for pre-booking and payment in the restaurants and cafes sector for take-out or internal orders and free delivery service.",
    "link": "/services-details",
    "images": [
      "/light/assets/imgs/service-img/IGI-app-img.webp",
      "/light/assets/imgs/service-img/IGI-landing.webp",
    ],
    "vid": "/light/assets/imgs/service-img/igi-landing-vid.mp4",
    "keyPoints": [
      "Pre-booking for dine-in and take-out orders.",
      "Free delivery services for online orders.",
      "Efficient payment process to save time."
    ],
    "callToAction": "Download IDI and enjoy seamless ordering from your favorite restaurants and cafes!",
    "competitiveAdvantage": "Combines pre-booking, payment, and free delivery in one seamless platform.",
    "url": "https://igi.com.sa/en",
    "downloads": {
      "ios" : {
        "icon": "/light/assets/imgs/logo/ios_icon.png",
        "url": "https://www.apple.com/sa/app"
      },
      "android" : {
        "icon": "/light/assets/imgs/logo/android_icon.png",
        "url": "https://play.google.com/store/games"
      }
    }
  },
  {
    "id": "1136789",
    "title": "Letaarafu App",
    "img": "/light/assets/imgs/logo/lft_logo.webp",
    "desc": "An innovative application that enriches the experience of visitors and pilgrims by connecting them with the local community through reliable services, including cultural visits, trips, products, and gifts, presented in a well-organized digital way that blends Islamic authenticity with a modern touch.",
    "link": "#",
    "images": [
      "/light/assets/imgs/service-img/ltf_landing_page.webp",
      "/light/assets/imgs/service-img/ltf_landing_page.webp",
    ],
    "vid": "/light/assets/imgs/service-img/lft_vid.mp4",
    "keyPoints": [
      "Pre-booking for dine-in and take-out orders.",
      "Free delivery services for online orders.",
      "Efficient payment process to save time."
    ],
    "callToAction": "Download Letarafo and enjoy seamless ordering from your favorite restaurants and cafes!",
    "competitiveAdvantage": "Combines pre-booking, payment, and free delivery in one seamless platform.",
    "url": "",
    "downloads": {
      "ios" : {
        "icon": "/light/assets/imgs/logo/",
        "url": "https://www.apple.com/sa/app"
      },
      "android" : {
        "icon": "/light/assets/imgs/logo/",
        "url": "https://play.google.com/store/games"
      }
    }
  }
]